
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tin-tuc",
      function () {
        return require("private-next-pages/tin-tuc/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/tin-tuc"])
      });
    }
  